import {Injectable} from '@angular/core';
import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {defaultFechaNull} from '../shared/constantes/fecha';
import * as moment from 'moment';
import * as lodash from 'lodash';

@Injectable({
   providedIn: 'root'
})
export class ToolsService {
   constructor() {
   }

//#region XML
   
   public parseXML(value: string) {
      const parser = new DOMParser();
      return parser.parseFromString(value, 'text/xml');
   }
   
   public formatterXML(xml: string): string {
      let chars = {
         '<': '&lt;',
         '>': '&gt;',
         '(': '&#40;',
         ')': '&#41;',
         '#': '&#35;',
         '&': '&amp;',
         '"': '&quot;',
         '\'': '&apos;'
      };
      
      let _return: string = xml;
      
      for (let key in chars) {
         let data = new RegExp(chars[key], 'g');
         
         _return = _return.replace(data, key);
      }
      
      return _return;
   }
   
   public getValueTagFromXML(document: string, tag: string): string {
      let sResult: string = undefined;
      let oRegEx: RegExpMatchArray;
      
      try {
         oRegEx = document.match('<' + tag + '>([\\s\\S]*)</' + tag + '>');
         
         if (oRegEx) {
            sResult = oRegEx[1];
         }
      } catch (e) {
         sResult = undefined;
      }
      
      return sResult;
   }

//#endregion XML

//#region Utils
   
   public getState(value: any, formatCase: string = 'UC'): string {
      let sResult: string = '***';
      
      switch (value) {
         case '0': {
            sResult = 'DESHABILITADO';
            break;
         }
         
         case '1': {
            sResult = 'ACTIVO';
            break;
         }
         
         default: {
            sResult = '***';
         }
      }
      
      if (formatCase === 'UC') {
         sResult = sResult.toUpperCase();
      } else if (formatCase === 'LC') {
         sResult = sResult.toLowerCase();
      } else {
         sResult = sResult.charAt(0) + sResult.toLowerCase().slice(1);
      }
      
      return sResult;
   }
   
   public optionsModalCatalog(): NgbModalOptions {
      return {
         ariaLabelledBy: 'modal-basic-title',
         size: 'lg',
         centered: true
      };
   }
   
   public setTitleCase(data: string) {
      if (data) {
         data = data.replace(/\s+/gi, ' ');
         
         const sentence = data.trim().toLowerCase().split(' ');
         
         for (let i = 0; i < sentence.length; i++) {
            if (sentence[i][0]) {
               sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
            }
         }
         
         return sentence.join(' ');
      } else {
         return data;
      }
   }
   
   public setUpperCase(data: any) {
      if (data.value) {
         return data.value.toUpperCase();
      } else {
         return '';
      }
   }
   
   public getTitleNumRegs(nNumRegs: number, bSetUpperCase: boolean = false): string {
      let sResult: string;
      
      this.getDataValueFormatInteger(nNumRegs);
      
      if (!nNumRegs) {
         sResult = '0 Registros';
      } else {
         sResult = nNumRegs === 1 ? '1 Registro' : nNumRegs.toString() + ' Registros';
      }
      return bSetUpperCase ? sResult.toUpperCase() : sResult;
   }
   
   public getListEstate() {
      return [
         {value: 1, label: 'ACTIVO'},
         {value: 0, label: 'DESHABILITADO'},
      ];
   }
   
   public getListSexo() {
      return [
         {value: 'F', label: 'FEMENINO'},
         {value: 'M', label: 'MASCULINO'},
         {value: '*', label: 'NO DETERMINADO'},
      ];
   }
   
   public getListMes() {
      return [
         {value: 1, label: 'ENERO'},
         {value: 2, label: 'FEBRERO'},
         {value: 3, label: 'MARZO'},
         {value: 4, label: 'ABRIL'},
         {value: 5, label: 'MAYO'},
         {value: 6, label: 'JUNIO'},
         {value: 7, label: 'JULIO'},
         {value: 8, label: 'AGOSTO'},
         {value: 9, label: 'SEPTIEMBRE'},
         {value: 10, label: 'OCTUBRE'},
         {value: 11, label: 'NOVIEMBRE'},
         {value: 12, label: 'DICIEMBRE'},
      ];
   }
   
   public getListYesNot() {
      return [
         {value: 'S', label: 'SÍ'},
         {value: 'N', label: 'NO'},
      ];
   }
   
   public getList10() {
      return [
         {value: 1, label: 'SÍ'},
         {value: 0, label: 'NO'},
      ];
   }
   
   public getList1Null() {
      return [
         {value: 1, label: 'SÍ'},
         {value: null, label: 'NO'},
      ];
   }
   
   public getListIconFeather() {
      return [
         {value: 'feather icon-activity', label: 'feather icon-activity'},
         {value: 'feather icon-airplay', label: 'feather icon-airplay'},
         {value: 'feather icon-alert-circle', label: 'feather icon-alert-circle'},
         {value: 'feather icon-alert-octagon', label: 'feather icon-alert-octagon'},
         {value: 'feather icon-alert-triangle', label: 'feather icon-alert-triangle'},
         {value: 'feather icon-align-center', label: 'feather icon-align-center'},
         {value: 'feather icon-align-justify', label: 'feather icon-align-justify'},
         {value: 'feather icon-align-left', label: 'feather icon-align-left'},
         {value: 'feather icon-align-right', label: 'feather icon-align-right'},
         {value: 'feather icon-anchor', label: 'feather icon-anchor'},
         {value: 'feather icon-aperture', label: 'feather icon-aperture'},
         {value: 'feather icon-arrow-down', label: 'feather icon-arrow-down'},
         {value: 'feather icon-arrow-down-left', label: 'feather icon-arrow-down-left'},
         {value: 'feather icon-arrow-down-right', label: 'feather icon-arrow-down-right'},
         {value: 'feather icon-arrow-left', label: 'feather icon-arrow-left'},
         {value: 'feather icon-arrow-right', label: 'feather icon-arrow-right'},
         {value: 'feather icon-arrow-up', label: 'feather icon-arrow-up'},
         {value: 'feather icon-arrow-up-left', label: 'feather icon-arrow-up-left'},
         {value: 'feather icon-arrow-up-right', label: 'feather icon-arrow-up-right'},
         {value: 'feather icon-at-sign', label: 'feather icon-at-sign'},
         {value: 'feather icon-award', label: 'feather icon-award'},
         {value: 'feather icon-bar-chart', label: 'feather icon-bar-chart'},
         {value: 'feather icon-bar-chart-2', label: 'feather icon-bar-chart-2'},
         {value: 'feather icon-battery', label: 'feather icon-battery'},
         {value: 'feather icon-battery-charging', label: 'feather icon-battery-charging'},
         {value: 'feather icon-bell', label: 'feather icon-bell'},
         {value: 'feather icon-bell-off', label: 'feather icon-bell-off'},
         {value: 'feather icon-bluetooth', label: 'feather icon-bluetooth'},
         {value: 'feather icon-bold', label: 'feather icon-bold'},
         {value: 'feather icon-book', label: 'feather icon-book'},
         {value: 'feather icon-bookmark', label: 'feather icon-bookmark'},
         {value: 'feather icon-box', label: 'feather icon-box'},
         {value: 'feather icon-briefcase', label: 'feather icon-briefcase'},
         {value: 'feather icon-calendar', label: 'feather icon-calendar'},
         {value: 'feather icon-camera', label: 'feather icon-camera'},
         {value: 'feather icon-camera-off', label: 'feather icon-camera-off'},
         {value: 'feather icon-cast', label: 'feather icon-cast'},
         {value: 'feather icon-check', label: 'feather icon-check'},
         {value: 'feather icon-check-circle', label: 'feather icon-check-circle'},
         {value: 'feather icon-check-square', label: 'feather icon-check-square'},
         {value: 'feather icon-chevron-down', label: 'feather icon-chevron-down'},
         {value: 'feather icon-chevron-left', label: 'feather icon-chevron-left'},
         {value: 'feather icon-chevron-right', label: 'feather icon-chevron-right'},
         {value: 'feather icon-chevrons-down', label: 'feather icon-chevrons-down'},
         {value: 'feather icon-chevrons-left', label: 'feather icon-chevrons-left'},
         {value: 'feather icon-chevrons-right', label: 'feather icon-chevrons-right'},
         {value: 'feather icon-chevrons-up', label: 'feather icon-chevrons-up'},
         {value: 'feather icon-chevron-up', label: 'feather icon-chevron-up'},
         {value: 'feather icon-chrome', label: 'feather icon-chrome'},
         {value: 'feather icon-circle', label: 'feather icon-circle'},
         {value: 'feather icon-clipboard', label: 'feather icon-clipboard'},
         {value: 'feather icon-clock', label: 'feather icon-clock'},
         {value: 'feather icon-cloud', label: 'feather icon-cloud'},
         {value: 'feather icon-cloud-drizzle', label: 'feather icon-cloud-drizzle'},
         {value: 'feather icon-cloud-lightning', label: 'feather icon-cloud-lightning'},
         {value: 'feather icon-cloud-off', label: 'feather icon-cloud-off'},
         {value: 'feather icon-cloud-rain', label: 'feather icon-cloud-rain'},
         {value: 'feather icon-cloud-snow', label: 'feather icon-cloud-snow'},
         {value: 'feather icon-codepen', label: 'feather icon-codepen'},
         {value: 'feather icon-command', label: 'feather icon-command'},
         {value: 'feather icon-compass', label: 'feather icon-compass'},
         {value: 'feather icon-copy', label: 'feather icon-copy'},
         {value: 'feather icon-corner-down-left', label: 'feather icon-corner-down-left'},
         {value: 'feather icon-corner-down-right', label: 'feather icon-corner-down-right'},
         {value: 'feather icon-corner-left-down', label: 'feather icon-corner-left-down'},
         {value: 'feather icon-corner-left-up', label: 'feather icon-corner-left-up'},
         {value: 'feather icon-corner-right-down', label: 'feather icon-corner-right-down'},
         {value: 'feather icon-corner-right-up', label: 'feather icon-corner-right-up'},
         {value: 'feather icon-corner-up-left', label: 'feather icon-corner-up-left'},
         {value: 'feather icon-corner-up-right', label: 'feather icon-corner-up-right'},
         {value: 'feather icon-cpu', label: 'feather icon-cpu'},
         {value: 'feather icon-credit-card', label: 'feather icon-credit-card'},
         {value: 'feather icon-crop', label: 'feather icon-crop'},
         {value: 'feather icon-crosshair', label: 'feather icon-crosshair'},
         {value: 'feather icon-delete', label: 'feather icon-delete'},
         {value: 'feather icon-disc', label: 'feather icon-disc'},
         {value: 'feather icon-download', label: 'feather icon-download'},
         {value: 'feather icon-download-cloud', label: 'feather icon-download-cloud'},
         {value: 'feather icon-droplet', label: 'feather icon-droplet'},
         {value: 'feather icon-edit', label: 'feather icon-edit'},
         {value: 'feather icon-edit-1', label: 'feather icon-edit-1'},
         {value: 'feather icon-edit-2', label: 'feather icon-edit-2'},
         {value: 'feather icon-external-link', label: 'feather icon-external-link'},
         {value: 'feather icon-eye', label: 'feather icon-eye'},
         {value: 'feather icon-eye-off', label: 'feather icon-eye-off'},
         {value: 'feather icon-facebook', label: 'feather icon-facebook'},
         {value: 'feather icon-fast-forward', label: 'feather icon-fast-forward'},
         {value: 'feather icon-feather', label: 'feather icon-feather'},
         {value: 'feather icon-file', label: 'feather icon-file'},
         {value: 'feather icon-file-minus', label: 'feather icon-file-minus'},
         {value: 'feather icon-file-plus', label: 'feather icon-file-plus'},
         {value: 'feather icon-file-text', label: 'feather icon-file-text'},
         {value: 'feather icon-film', label: 'feather icon-film'},
         {value: 'feather icon-filter', label: 'feather icon-filter'},
         {value: 'feather icon-flag', label: 'feather icon-flag'},
         {value: 'feather icon-folder', label: 'feather icon-folder'},
         {value: 'feather icon-github', label: 'feather icon-github'},
         {value: 'feather icon-gitlab', label: 'feather icon-gitlab'},
         {value: 'feather icon-globe', label: 'feather icon-globe'},
         {value: 'feather icon-grid', label: 'feather icon-grid'},
         {value: 'feather icon-hash', label: 'feather icon-hash'},
         {value: 'feather icon-headphones', label: 'feather icon-headphones'},
         {value: 'feather icon-heart', label: 'feather icon-heart'},
         {value: 'feather icon-heart-on', label: 'feather icon-heart-on'},
         {value: 'feather icon-help-circle', label: 'feather icon-help-circle'},
         {value: 'feather icon-home', label: 'feather icon-home'},
         {value: 'feather icon-image', label: 'feather icon-image'},
         {value: 'feather icon-inbox', label: 'feather icon-inbox'},
         {value: 'feather icon-info', label: 'feather icon-info'},
         {value: 'feather icon-instagram', label: 'feather icon-instagram'},
         {value: 'feather icon-italic', label: 'feather icon-italic'},
         {value: 'feather icon-layers', label: 'feather icon-layers'},
         {value: 'feather icon-layout', label: 'feather icon-layout'},
         {value: 'feather icon-life-buoy', label: 'feather icon-life-buoy'},
         {value: 'feather icon-link', label: 'feather icon-link'},
         {value: 'feather icon-link-2', label: 'feather icon-link-2'},
         {value: 'feather icon-list', label: 'feather icon-list'},
         {value: 'feather icon-loader', label: 'feather icon-loader'},
         {value: 'feather icon-lock', label: 'feather icon-lock'},
         {value: 'feather icon-log-in', label: 'feather icon-log-in'},
         {value: 'feather icon-log-out', label: 'feather icon-log-out'},
         {value: 'feather icon-mail', label: 'feather icon-mail'},
         {value: 'feather icon-map', label: 'feather icon-map'},
         {value: 'feather icon-map-pin', label: 'feather icon-map-pin'},
         {value: 'feather icon-maximize', label: 'feather icon-maximize'},
         {value: 'feather icon-maximize-2', label: 'feather icon-maximize-2'},
         {value: 'feather icon-menu', label: 'feather icon-menu'},
         {value: 'feather icon-message-circle', label: 'feather icon-message-circle'},
         {value: 'feather icon-message-square', label: 'feather icon-message-square'},
         {value: 'feather icon-mic', label: 'feather icon-mic'},
         {value: 'feather icon-mic-off', label: 'feather icon-mic-off'},
         {value: 'feather icon-minimize', label: 'feather icon-minimize'},
         {value: 'feather icon-minimize-2', label: 'feather icon-minimize-2'},
         {value: 'feather icon-minus', label: 'feather icon-minus'},
         {value: 'feather icon-minus-circle', label: 'feather icon-minus-circle'},
         {value: 'feather icon-minus-square', label: 'feather icon-minus-square'},
         {value: 'feather icon-monitor', label: 'feather icon-monitor'},
         {value: 'feather icon-moon', label: 'feather icon-moon'},
         {value: 'feather icon-more-horizontal', label: 'feather icon-more-horizontal'},
         {value: 'feather icon-more-vertical', label: 'feather icon-more-vertical'},
         {value: 'feather icon-move', label: 'feather icon-move'},
         {value: 'feather icon-music', label: 'feather icon-music'},
         {value: 'feather icon-navigation', label: 'feather icon-navigation'},
         {value: 'feather icon-navigation-2', label: 'feather icon-navigation-2'},
         {value: 'feather icon-octagon', label: 'feather icon-octagon'},
         {value: 'feather icon-package', label: 'feather icon-package'},
         {value: 'feather icon-paperclip', label: 'feather icon-paperclip'},
         {value: 'feather icon-pause', label: 'feather icon-pause'},
         {value: 'feather icon-pause-circle', label: 'feather icon-pause-circle'},
         {value: 'feather icon-percent', label: 'feather icon-percent'},
         {value: 'feather icon-phone', label: 'feather icon-phone'},
         {value: 'feather icon-phone-call', label: 'feather icon-phone-call'},
         {value: 'feather icon-phone-forwarded', label: 'feather icon-phone-forwarded'},
         {value: 'feather icon-phone-incoming', label: 'feather icon-phone-incoming'},
         {value: 'feather icon-phone-missed', label: 'feather icon-phone-missed'},
         {value: 'feather icon-phone-off', label: 'feather icon-phone-off'},
         {value: 'feather icon-phone-outgoing', label: 'feather icon-phone-outgoing'},
         {value: 'feather icon-pie-chart', label: 'feather icon-pie-chart'},
         {value: 'feather icon-play', label: 'feather icon-play'},
         {value: 'feather icon-play-circle', label: 'feather icon-play-circle'},
         {value: 'feather icon-plus', label: 'feather icon-plus'},
         {value: 'feather icon-plus-circle', label: 'feather icon-plus-circle'},
         {value: 'feather icon-plus-square', label: 'feather icon-plus-square'},
         {value: 'feather icon-pocket', label: 'feather icon-pocket'},
         {value: 'feather icon-power', label: 'feather icon-power'},
         {value: 'feather icon-printer', label: 'feather icon-printer'},
         {value: 'feather icon-radio', label: 'feather icon-radio'},
         {value: 'feather icon-refresh-ccw', label: 'feather icon-refresh-ccw'},
         {value: 'feather icon-refresh-cw', label: 'feather icon-refresh-cw'},
         {value: 'feather icon-repeat', label: 'feather icon-repeat'},
         {value: 'feather icon-rewind', label: 'feather icon-rewind'},
         {value: 'feather icon-rotate-ccw', label: 'feather icon-rotate-ccw'},
         {value: 'feather icon-rotate-cw', label: 'feather icon-rotate-cw'},
         {value: 'feather icon-save', label: 'feather icon-save'},
         {value: 'feather icon-scissors', label: 'feather icon-scissors'},
         {value: 'feather icon-search', label: 'feather icon-search'},
         {value: 'feather icon-server', label: 'feather icon-server'},
         {value: 'feather icon-settings', label: 'feather icon-settings'},
         {value: 'feather icon-share', label: 'feather icon-share'},
         {value: 'feather icon-share-2', label: 'feather icon-share-2'},
         {value: 'feather icon-shield', label: 'feather icon-shield'},
         {value: 'feather icon-shopping-cart', label: 'feather icon-shopping-cart'},
         {value: 'feather icon-shuffle', label: 'feather icon-shuffle'},
         {value: 'feather icon-sidebar', label: 'feather icon-sidebar'},
         {value: 'feather icon-skip-back', label: 'feather icon-skip-back'},
         {value: 'feather icon-skip-forward', label: 'feather icon-skip-forward'},
         {value: 'feather icon-slack', label: 'feather icon-slack'},
         {value: 'feather icon-slash', label: 'feather icon-slash'},
         {value: 'feather icon-sliders', label: 'feather icon-sliders'},
         {value: 'feather icon-smartphone', label: 'feather icon-smartphone'},
         {value: 'feather icon-speaker', label: 'feather icon-speaker'},
         {value: 'feather icon-square', label: 'feather icon-square'},
         {value: 'feather icon-star', label: 'feather icon-star'},
         {value: 'feather icon-star-on', label: 'feather icon-star-on'},
         {value: 'feather icon-stop-circle', label: 'feather icon-stop-circle'},
         {value: 'feather icon-sun', label: 'feather icon-sun'},
         {value: 'feather icon-sunrise', label: 'feather icon-sunrise'},
         {value: 'feather icon-sunset', label: 'feather icon-sunset'},
         {value: 'feather icon-tablet', label: 'feather icon-tablet'},
         {value: 'feather icon-tag', label: 'feather icon-tag'},
         {value: 'feather icon-target', label: 'feather icon-target'},
         {value: 'feather icon-thermometer', label: 'feather icon-thermometer'},
         {value: 'feather icon-thumbs-down', label: 'feather icon-thumbs-down'},
         {value: 'feather icon-thumbs-up', label: 'feather icon-thumbs-up'},
         {value: 'feather icon-toggle-left', label: 'feather icon-toggle-left'},
         {value: 'feather icon-toggle-right', label: 'feather icon-toggle-right'},
         {value: 'feather icon-trash', label: 'feather icon-trash'},
         {value: 'feather icon-trash-2', label: 'feather icon-trash-2'},
         {value: 'feather icon-trending-down', label: 'feather icon-trending-down'},
         {value: 'feather icon-trending-up', label: 'feather icon-trending-up'},
         {value: 'feather icon-triangle', label: 'feather icon-triangle'},
         {value: 'feather icon-tv', label: 'feather icon-tv'},
         {value: 'feather icon-twitter', label: 'feather icon-twitter'},
         {value: 'feather icon-type', label: 'feather icon-type'},
         {value: 'feather icon-umbrella', label: 'feather icon-umbrella'},
         {value: 'feather icon-underline', label: 'feather icon-underline'},
         {value: 'feather icon-unlock', label: 'feather icon-unlock'},
         {value: 'feather icon-upload', label: 'feather icon-upload'},
         {value: 'feather icon-upload-cloud', label: 'feather icon-upload-cloud'},
         {value: 'feather icon-user', label: 'feather icon-user'},
         {value: 'feather icon-user-check', label: 'feather icon-user-check'},
         {value: 'feather icon-user-minus', label: 'feather icon-user-minus'},
         {value: 'feather icon-user-plus', label: 'feather icon-user-plus'},
         {value: 'feather icon-users', label: 'feather icon-users'},
         {value: 'feather icon-user-x', label: 'feather icon-user-x'},
         {value: 'feather icon-video', label: 'feather icon-video'},
         {value: 'feather icon-video-off', label: 'feather icon-video-off'},
         {value: 'feather icon-voicemail', label: 'feather icon-voicemail'},
         {value: 'feather icon-volume', label: 'feather icon-volume'},
         {value: 'feather icon-volume-1', label: 'feather icon-volume-1'},
         {value: 'feather icon-volume-2', label: 'feather icon-volume-2'},
         {value: 'feather icon-volume-x', label: 'feather icon-volume-x'},
         {value: 'feather icon-watch', label: 'feather icon-watch'},
         {value: 'feather icon-wifi', label: 'feather icon-wifi'},
         {value: 'feather icon-wifi-off', label: 'feather icon-wifi-off'},
         {value: 'feather icon-wind', label: 'feather icon-wind'},
         {value: 'feather icon-x', label: 'feather icon-x'},
         {value: 'feather icon-x-circle', label: 'feather icon-x-circle'},
         {value: 'feather icon-x-square', label: 'feather icon-x-square'},
         {value: 'feather icon-zap', label: 'feather icon-zap'},
         {value: 'feather icon-zoom-in', label: 'feather icon-zoom-in'},
         {value: 'feather icon-zoom-out', label: 'feather icon-zoom-out'}
      ];
   }
   
   public removeJsonKey(data: any, keys: any) {
      if (data === null || data === undefined) {
         return data;
      }
      
      let item = {}, key;
      
      for (key in data) {
         let inside = keys.indexOf(key);
         
         if (inside !== -1) {
            continue;
         }
         
         if (typeof data[key] === 'object') {
            item[key] = this.removeJsonKey(data[key], keys);
         } else {
            item[key] = data[key];
         }
      }
      
      return item;
   }
   
   public getTree(lsData: any[], sFieldId: string, sFieldParent: string): any[] {
      let lsTree: any[];
      
      lsTree = lsData
        .filter((oItem: any) => oItem[sFieldParent] === null)
        .map((oItem: any) => {
           oItem.Childs = this.getTreeChilds(lsData, sFieldId, sFieldParent, oItem[sFieldId]);
           oItem.ChildsCount = oItem.Childs != undefined ? oItem.Childs.length : 0;
           
           return oItem;
        });
      
      return lsTree;
   }
   
   private getTreeChilds(lsData: any[], sFieldId: string, sFieldParent: string, idParent: number): any[] {
      let lsResult = lsData.filter(oItem => oItem[sFieldParent] === idParent);
      
      for (let oItem of lsResult) {
         oItem.Childs = this.getTreeChilds(lsData, sFieldId, sFieldParent, oItem[sFieldId]);
      }
      
      return lsResult;
   }

//#endregion Utils

//#region Date
   
   public today(format?: string) {
      return moment().format(format ? format : 'YYYY-MM-DD');
   }
   
   public getMomentFormat(value) {
      return moment(value).format('YYYY-MM-DD');
   }
   
   public parseDate(fecha: any, format?: string) {
      if (!fecha || fecha === defaultFechaNull) {
         return null;
      }
      
      return moment(fecha).format(format ? format : 'YYYY-MM-DD');
   }
   
   //#endregion Date

//#region Pagination
   
   public getLimit() {
      return [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
   }
   
   public getLimitPageSize(): number[] {
      return [5, 10, 15, 20, 25, 30, 40, 50, 100, 200, 500];
   }
   
   public getLimitPageSizeLarge(): number[] {
      return [5, 10, 25, 50, 100, 200, 500, 1000, 5000, 10000];
   }
   
   public pagSize(): number[] {
      const sizes = [5, 10, 15, 20, 25, 30, 40, 50, 100];
      return sizes;
   }

//#endregion Pagination

//#region Number
   
   public parseNumberToInt(value: any): number {
      try {
         return parseInt(value.toString().replace(/,/g, ''));
      } catch (e) {
         return 0;
      }
   }
   
   public parseNumberToFloat(value: any): number {
      try {
         return parseFloat(value.toString().replace(/,/g, ''));
      } catch (e) {
         return 0;
      }
   }
   
   public parseNumberToFloatRounded(value: any, numDecimal: number): number {
      try {
         return Number(parseFloat(value.toString().replace(/,/g, '')).toFixed(numDecimal));
      } catch (e) {
         return 0;
      }
   }
   
   public roundNumber(num, scale: number = 2) {
      const flotante = parseFloat(num);
      
      return Math.round(flotante * Math.pow(10, scale)) / Math.pow(10, scale);
   }
   
   public genRamdomNumber(inferior: number, superior: number) {
      let numPosibilidades = superior - inferior;
      let aleat = Math.random() * numPosibilidades;
      
      aleat = Math.floor(aleat);
      
      return parseInt(inferior.toString()) + aleat;
   }

//#endregion Number

//#region Array
   
   public isGetArray(value: any): any[] {
      return Array.isArray(value) ? value : [value];
   }
   
   public setArraySort(lsArray) {
      lsArray.sort((a, b) => {
         return ((a.label < b.label) ? -1 : ((a.label > b.label) ? 1 : 0));
      });
   }
   
   public setArraySortByKey(lsArray: any, sKey: string, bAscendant: boolean, iTopSlice: number): any[] {
      let lsResult: any[];
      
      if (bAscendant) {
         lsResult = lsArray.sort((a, b) => (a[sKey] > b[sKey]) ? 1 : -1);
      } else {
         lsResult = lsArray.sort((a, b) => (a[sKey] < b[sKey]) ? 1 : -1);
      }
      
      if (iTopSlice > 0) {
         return lsResult.slice(0, iTopSlice);
      } else {
         return lsResult.slice();
      }
   }
   
   public getArrayResumev1(lsData: any[], oTemplateInteger: any, oTemplateDecimal: any, sKeyGroup: string): any {
      if (lsData.length <= 0) {
         return;
      }
      
      const lsDataResume = lsData.reduce((lsArray, oItem) => {
         let oKeyVal = oItem[sKeyGroup];
         
         if (oTemplateInteger != null && oTemplateDecimal != null) {
            lsArray[oKeyVal] = lsArray[oKeyVal] || {ITEM: oItem[sKeyGroup], ...oTemplateInteger, ...oTemplateDecimal};
         } else if (oTemplateInteger != null && oTemplateDecimal == null) {
            lsArray[oKeyVal] = lsArray[oKeyVal] || {ITEM: oItem[sKeyGroup], ...oTemplateInteger};
         } else if (oTemplateInteger == null && oTemplateDecimal != null) {
            lsArray[oKeyVal] = lsArray[oKeyVal] || {ITEM: oItem[sKeyGroup], ...oTemplateDecimal};
         }
         
         if (oTemplateInteger != null) {
            for (let oKeyColumn in oTemplateInteger) {
               lsArray[oKeyVal][oKeyColumn] += Number.parseInt(oItem[oKeyColumn]);
            }
         }
         
         if (oTemplateDecimal != null) {
            for (let oKeyColumn in oTemplateDecimal) {
               lsArray[oKeyVal][oKeyColumn] += Number.parseFloat(oItem[oKeyColumn]);
            }
         }
         
         return lsArray;
      }, {});
      
      return lsDataResume;
   }
   
   public getArrayResumev2(lsData: any[], sTypeColumnSum: string, sKeyGroup: string, sKeySum: string): any {
      if (lsData.length <= 0) {
         return;
      }
      
      let lsResult: any[] = new Array<[]>();
      
      let lsDataResume: any[] = lsData.reduce((lsArray, oItem) => {
         let oKeyVal = oItem[sKeyGroup];
         
         lsArray[oKeyVal] = lsArray[oKeyVal] || {ITEM: oItem[sKeyGroup], VALUE: 0};
         
         if (sTypeColumnSum == 'i') {
            lsArray[oKeyVal]['VALUE'] += Number.parseInt(oItem[sKeySum]);
         } else if (sTypeColumnSum == 'd') {
            lsArray[oKeyVal]['VALUE'] += Number.parseFloat(oItem[sKeySum]);
         }
         
         return lsArray;
      }, {});
      
      if (lsDataResume != undefined && lsDataResume != null) {
         for (let key in lsDataResume) {
            let sText: string = lsDataResume[key]['ITEM'];
            let dValue: number = lsDataResume[key]['VALUE'];
            
            if (sText == undefined || sText == null) {
               sText = 'SIN CLASIFICAR';
            }
            
            lsResult.push({ITEM: sText, VALUE: dValue});
         }
      }
      
      return lsResult;
   }
   
   public getSumFieldArray(lsData: any[], sField: string): number {
      let nResult: number = 0;
      
      for (let oItem of lsData) {
         nResult += oItem[sField];
      }
      
      return nResult;
   }
   
   public getDistinctByKey(lsData: any[], sField: string): any[] {
      let lsResult: any[];
      
      if (lsData.length > 0) {
         lsResult = lodash.uniq(lsData.map((item: any) => item[sField]));
      } else {
         lsResult = [];
      }
      
      
      return lsResult;
   }

//#endregion Array

//#region Format
   public formatCurrency(value: any) {
      let formatter = new Intl.NumberFormat('en-US', {
         style: 'currency',
         currency: 'USD',
      });
      
      return formatter.format(value);
   }
   
   public getValueFormatInteger(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 0,
               maximumFractionDigits: 0
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getValueFormatNumber(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getValueFormatCurrency(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'currency',
               currency: 'USD',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getValueFormatPercent(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'percent',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public formatearCrecimientosIMS(data: any) {
      let value: number = 0;
      let result: string = '';
      
      value = data.value;
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         } else {
            result = '-';
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }

//#endregion Format

//#region Format Standar
   
   public getDataValueFormatInteger(value: any) {
      let result: string = '';
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 0,
               maximumFractionDigits: 0
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getDataValueFormatNumber(value: any) {
      let result: string = '';
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getDataValueFormatCurrency(value: any) {
      let result: string = '';
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'currency',
               currency: 'USD',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public getDataValueFormatPercent(value: any) {
      let result: string = '';
      
      try {
         if (value !== null && value !== undefined) {
            result = value.toLocaleString('en-US', {
               style: 'percent',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }

//#endregion Format Standar

//#region Summary Cols ngx-datatable
   
   public dataTableSummaryRowNull(cells: any[]) {
      return '';
   }
   
   public dataTableSummaryRowLabelTotals(cells: any[]) {
      return 'TOTALES';
   }
   
   public dataTableSummaryCount(cells: any[]) {
      return cells.length.toString() + ' Regs.';
   }
   
   public dataTableSummaryRowInteger(cells: any[]) {
      let data: number = 0;
      let result: string = '';
      
      try {
         data = cells.reduce((res, cell) => res += cell, 0);
         
         if (data !== null && data !== undefined) {
            result = data.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 0,
               maximumFractionDigits: 0
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public dataTableSummaryRowNumber(cells: any[]) {
      let data: number = 0;
      let result: string = '';
      
      try {
         data = cells.reduce((res, cell) => res += cell, 0);
         
         if (data !== null && data !== undefined) {
            result = data.toLocaleString('en-US', {
               style: 'decimal',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public dataTableSummaryRowCurrency(cells: any[]) {
      let data: number = 0;
      let result: string = '';
      
      try {
         data = cells.reduce((res, cell) => res += cell, 0);
         
         if (data !== null && data !== undefined) {
            result = data.toLocaleString('en-US', {
               style: 'currency',
               currency: 'USD',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public dataTableSummaryRowPercent(cells: any[]) {
      let data: number = 0;
      let result: string = '';
      
      try {
         data = cells.reduce((res, cell) => res += cell, 0) / 100;
         
         if (data !== null && data !== undefined) {
            result = data.toLocaleString('en-US', {
               style: 'percent',
               useGrouping: true,
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
            });
         }
      } catch (e) {
         result = '';
      }
      
      return result;
   }
   
   public validateRUC(
     ruc: string
   ) {
      const longitudRUC = ruc.length;
      const tipoValor = typeof +ruc;
      if (tipoValor === 'number') {
         if (!ruc || ruc == '') {
            return 'No se ha ingresado el RUC';
         } else {
            if (longitudRUC !== 13) {
               return 'Ingrese solamente 13 dígitos para el RUC';
            } else {
               const validacionTresUltimosDigitos = ruc.substring(10, 13) === '001';
               if (validacionTresUltimosDigitos) {
                  const codigoProvincia = +(ruc.substring(0, 2));
                  const validacionDosPrimerosDigitos = codigoProvincia > 0 && codigoProvincia < 25;
                  
                  if (validacionDosPrimerosDigitos) {
                     const tercerDigito = +(ruc.substring(2, 3));
                     if (tercerDigito > 0 && tercerDigito < 6) {
                        return this.verificarDigitoAutoVerificador(
                          ruc.substring(0, 9).split(''),
                          [2, 1, 2, 1, 2, 1, 2, 1, 2],
                          10,
                          ruc.substring(9, 10),
                        );
                     }
                     if (tercerDigito === 9) {
                        return this.verificarDigitoAutoVerificador(
                          ruc.substring(0, 9).split(''),
                          [4, 3, 2, 7, 6, 5, 4, 3, 2],
                          11,
                          ruc.substring(9, 10),
                        );
                     }
                     if (tercerDigito === 6) {
                        return this.verificarDigitoAutoVerificador(
                          ruc.substring(0, 8).split(''),
                          [3, 2, 7, 6, 5, 4, 3, 2],
                          11,
                          ruc.substring(8, 9),
                        );
                     }
                     
                     if (tercerDigito === 0) {
                        return 'OK';
                     }
                  } else {
                     return 'El código de provincia del RUC es incorrecto';
                  }
               } else {
                  return 'Los tres últimos dígitos del RUC no tienen el código 001';
               }
            }
         }
      } else {
         return 'Ingrese solo números para el RUC';
      }
   }
   
   verificarDigitoAutoVerificador(
     digitos: string[],
     coeficientes: number[],
     modulo: number,
     digitoAutoVerificador: string,
   ) {
      let resto;
      const tercerDigito = +(digitos[2]);
      if (digitos.length === coeficientes.length) {
         const sumaProductoDigitosCoeficientes = digitos.reduce((valorInicial, digito, indice) => {
            const producto = +digito * coeficientes[indice];
            let resultado = 0;
            if (tercerDigito > 0 && tercerDigito < 6) {
               if (producto >= 10) {
                  resultado = valorInicial + (producto - 9);
               } else {
                  resultado = valorInicial + producto;
               }
            } else {
               resultado = valorInicial + producto;
            }
            return resultado;
         }, 0);
         const moduloCalculado = sumaProductoDigitosCoeficientes % modulo;
         resto = moduloCalculado === 0 ? 0 : (modulo - moduloCalculado);
         if (resto === +digitoAutoVerificador) {
            return 'OK';
         } else {
            return 'El RUC ingresado es incorrecto';
         }
      } else {
         return 'Error al verIficar el RUC';
      }
   }
   
   eliminarDuplicadoArray(arreglo: any[]): any[] {
      return arreglo.reduce((acc, item) => {
         if (!acc.includes(item)) {
            acc.push(item);
         }
         return acc;
      }, []);
   }
   
   eliminarDuplicadoArrayObjetos(
     array: any[],
     campo: string,
   ): any[] {
      const hash = {};
      return array.filter((o) =>
        hash[o[campo]] ? false : (hash[o[campo]] = true),
      );
   }

//#endregion Summary Cols ngx-datatable
}
